import { GetTransactionPackageSizesArgs } from 'types/api/arguments/get-transaction-package-sizes-args'
import { PackageSizesResp } from 'types/api/response/package-sizes-resp'

import { api } from './api'

export const getTransactionPackageSizes = ({ transactionId }: GetTransactionPackageSizesArgs) =>
  api.get<PackageSizesResp>(`/transactions/${transactionId}/package_sizes`)
